import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CLINIC_NAME, DEFAULT_LOCAL_PATH } from '../../constents';
import setUiMessage from '../../Utilities/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import { setAuthUser } from '../../redux/slices/auth/authSlice';
import { updateSearchParams } from '../../redux/slices/scheduler/appointmentSlice';
import { defSchedTab, defTimeFormate } from '../../redux/slices/appSlice';
import { isEmptyObject } from '../../Utilities/Utilities';
import useFormValidation from '../../hooks/zodFormValidation';
import appSchema from '../../schema/appSchema';
import { post } from './AuthToken';

function Login() {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [togelType, setTogelType] = useState(false);
  const [isSubmit, setSubmit] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  //const { getUser } = Authuser();
  const navigate = useNavigate();
  const formRef = useRef(null);

  const { errors, validateForm } = useFormValidation({
    schema: appSchema.formSchema(),
    formData: { username, password },
    isSubmit,
  });

  useEffect(() => {
    if (user) {
      navigate(`${DEFAULT_LOCAL_PATH}/scheduler`);
    } else {
      navigate(DEFAULT_LOCAL_PATH);
    }
  }, [user, navigate]);

  useEffect(() => {
    formRef.current?.focus();
  }, []);

  useEffect(() => {
    setErrMsg('');
  }, [username, password]);

  const signIn = async (e) => {
    e.preventDefault();
    setSubmit(true);

    // Validation
    const validationError = validateForm();
    if (validationError) return;
    try {
      const response = await post('api/auth/signin', {
        userName: username,
        password: password,
      });
      const resData = JSON.stringify(response?.data);
      if (response?.data?.status === 'ok' && response?.data?.token) {
        localStorage.setItem('userdata', resData);
        dispatch(setAuthUser(response.data.user));
        dispatch(
          updateSearchParams({
            key: 'clinicLocation',
            value: response.data.user.defaultLoc,
          })
        );

        dispatch(
          updateSearchParams({
            key: 'allProviders',
            value: response?.data?.user?.id,
          })
        );
        if (
          response.data.user?.glsstsettins?.ch_default_appointment_tab === '1'
        ) {
          dispatch(defSchedTab('aptOpen'));
        }
        dispatch(
          defTimeFormate(
            response.data.user?.glsstsettins?.ch_default_time_format ===
              '24 Hours'
              ? {
                  withoutSecond: 'HH:mm',
                  withSecons: 'HH:mm:ss',
                }
              : {
                  withoutSecond: 'hh:mm a',
                  withSecons: 'hh:mm:ss a',
                }
          )
        );
        navigate(`${DEFAULT_LOCAL_PATH}/scheduler`);
      } else if (response?.data?.status === 'fail') {
        setUiMessage('err', response?.data?.message);
      }
    } catch (err) {
      setErrMsg(err?.response.data.message);
    }
  };

  return (
    <div className="login">
      <div className="login_logo">
        <img src="./images/medgre-logo1.png" alt="Provider clinic details" />
        <span className="compny_name">{CLINIC_NAME}</span>
      </div>
      <div className="login_container">
        <h1>Login:</h1>
        <p className="red" aria-live="assertive">
          {errMsg}
        </p>
        <form className="grid-sec">
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            id="username"
            autoComplete="off"
            required
            value={username}
            ref={formRef}
            onChange={(e) => setUsername(e.target.value)}
            style={{ marginBottom: 'unset' }}
          />
          <p className="error" style={{ marginBottom: '25px' }}>
            {errors?.username && errors?.username?.message}
          </p>
          <label htmlFor="password">Password:</label>
          <span style={{ position: 'relative' }}>
            <input
              type={togelType ? 'text' : 'password'}
              id="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ marginBottom: 'unset' }}
            />
            <img
              src="./images/Access.png"
              alt="show password"
              width="10%"
              onClick={() => setTogelType(!togelType)}
              className="rvl-pswrd"
            />
          </span>
          <p className="error" style={{ marginBottom: '25px' }}>
            {errors?.password ? errors?.password?.message : ` `}
          </p>

          <div className="">
            <input type="checkbox" className="rmembr_me" />
            Remember me
            <input type="checkbox" className="frgt_paswrd" />
            Forgot Password?
          </div>
          <button
            disabled={!isEmptyObject(errors)}
            onClick={signIn}
            className="login__signInButton"
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
